import { formatLoggedTime } from "./formatLoggedTime";

export const formatTotalLoggedTime = (minutes?: number | null, days?: number | null) => {
  const finalMinutes = minutes ?? 0;
  const finalDays = days ?? 0;

  const hourly = formatLoggedTime(finalMinutes, "HOURLY");
  const daily = formatLoggedTime(finalDays, "DAILY");

  return finalMinutes > 0 && finalDays > 0 ? `${hourly} + ${daily}` : finalDays > 0 ? daily : hourly;
};
